<template>
  <section class="flex flex-grow-0 flex-row flex-wrap items-center gap-1 p-1">
    <slot />
  </section>
</template>
